import React, { useState, useEffect } from 'react';
import './Location.css';
import { API_URL } from './config';

function Location() {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/branches`)
      .then(r => r.json())
      .then(d => setBranches(d.branches || []))
      .catch(() => setError('Network error.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="location-container"><p>Loading…</p></div>;
  if (error) return <div className="location-container"><p>{error}</p></div>;

  // A branch with no display_name yet just hasn't had its Location content filled in -- no
  // card, rather than showing a mostly-blank one. Map/directions are always built from the
  // address fields here, never stored separately, so they can't drift out of sync with an edit.
  const locations = branches
    .filter(b => b.display_name)
    .map(b => {
      const addressParts = [b.facility_name, b.address_line1, b.address_line2].filter(Boolean);
      const fullAddress = addressParts.join(', ');
      return {
        ...b,
        addressParts,
        googleMapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`,
        embedSrc: `https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`,
      };
    });

  return (
    <div className="location-container">
      <h1 className="location-title">Location</h1>

      {locations.length === 0 ? (
        <p>Location details are coming soon.</p>
      ) : (
        <>
          <div className="location-info-row" style={{ '--location-count': locations.length }}>
            {locations.map(loc => (
              <div className="location-info-section" key={loc.id}>
                <h2>{loc.display_name}</h2>

                {loc.addressParts.length > 0 && (
                  <div className="info-card">
                    <h3>Address</h3>
                    <p className="address-text">
                      {loc.facility_name && <><strong>{loc.facility_name}</strong><br /></>}
                      {loc.address_line1 && <>{loc.address_line1}<br /></>}
                      {loc.address_line2}
                    </p>
                  </div>
                )}

                {(loc.hours_text || loc.hours_note) && (
                  <div className="info-card">
                    <h3>School Hours</h3>
                    {loc.hours_text && <p>{loc.hours_text}</p>}
                    {loc.hours_note && <p className="note">{loc.hours_note}</p>}
                  </div>
                )}

                {loc.addressParts.length > 0 && (
                  <div className="info-card">
                    <h3>Get Directions</h3>
                    <a
                      href={loc.googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="directions-button"
                    >
                      Open in Google Maps
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="location-maps-row" style={{ '--location-count': locations.length }}>
            {locations.filter(loc => loc.addressParts.length > 0).map(loc => (
              <div className="location-map-section" key={loc.id}>
                <h3 className="map-label">{loc.display_name}</h3>
                <iframe
                  title={`${loc.display_name} Map`}
                  src={loc.embedSrc}
                  width="100%"
                  height="400"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default Location;
